// import React, { useState } from "react";

// const Description = ({ Description }) => {
//   const [expanded, setExpanded] = useState(false);

//   const toggleDescription = () => {
//     setExpanded(!expanded);
//   };

//   const truncatedText = Description.length > 150 ? Description.slice(0, 150) + "..." : Description;

//   return (
//     <div className="mt-5 animate-slide-in">
//       <h2 className="text-2xl font-bold mb-2 text-orange-500">Description</h2>
//       <p className="text-gray-700 text-sm leading-relaxed">
//         {expanded ? Description : truncatedText}
//         {Description.length > 150 && (
//           <button 
//             onClick={toggleDescription} 
//             className="text-blue-500 ml-2 underline text-sm font-semibold"
//           >
//             {expanded ? "Read Less" : "Read More"}
//           </button>
//         )}
//       </p>
//     </div>
//   );
// };

// export default Description;

import React, { useState, useEffect } from "react";

const Description = ({ htmlString }) => {
  const [expanded, setExpanded] = useState(false);
  const [truncatedHtml, setTruncatedHtml] = useState("");

  useEffect(() => {
    if (!htmlString) return;

    // Remove tags to measure text length
    const textOnly = htmlString.replace(/<[^>]+>/g, "");

    if (textOnly.length > 150) {
      setTruncatedHtml(textOnly.slice(0, 150) + "...");
    } else {
      setTruncatedHtml(htmlString);
    }
  }, [htmlString]);

  return (
    // 1. Added 'text-left' here to ensure the container aligns left
    <div className="mt-5 animate-slide-in text-left">
      <h2 className="text-2xl font-bold mb-2 text-orange-500">Description</h2>

      <div
        // 2. Added 'text-left' here to force the inner HTML text to align left
        className="text-gray-700 text-sm leading-relaxed text-left"
        dangerouslySetInnerHTML={{
          __html: expanded ? htmlString : truncatedHtml,
        }}
      />

      {/* Logic update: Only show button if text is actually long enough to truncate */}
      {htmlString && htmlString.replace(/<[^>]+>/g, "").length > 150 && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="text-blue-500 mt-2 underline text-sm font-semibold"
        >
          {expanded ? "Read Less" : "Read More"}
        </button>
      )}
    </div>
  );
};

export default Description;